import React from 'react';
import { Link } from 'react-router-dom';
import wordmark from '../assets/wordmark.svg';
import SafeImage from './SafeImage';

const Footer: React.FC = () => {
    return (
        <footer style={{
            backgroundColor: '#000',
            color: '#fff',
            paddingTop: '4rem',
            paddingBottom: '2rem',
            marginTop: '4rem',
            minHeight: '400px' // Prevent massive layout shift when footer loads
        }}>
            <div className="container">

                {/* Top Section: Navigation Columns */}
                {/* Top Section: Navigation Columns */}
                {/* Top Section: Navigation Columns */}
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '2rem', borderBottom: '1px solid #333', paddingBottom: '3rem', marginBottom: '2rem' }}>

                    {/* Column 1: About */}
                    <div>
                        <h4 style={{ fontSize: '0.9rem', fontWeight: 800, marginBottom: '1.5rem', color: '#fff' }}>اسان بابت</h4>
                        <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
                            <li><Link to="/about" style={{ color: '#ccc', fontSize: '0.95rem', fontWeight: 400, textDecoration: 'none' }}>اسان جي تاريخ</Link></li>
                        </ul>
                    </div>

                    {/* Column 2: Submit Work (NEW) */}
                    <div>
                        <h4 style={{ fontSize: '0.9rem', fontWeight: 800, marginBottom: '1.5rem', color: '#fff' }}>ليک موڪليو</h4>
                        <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
                            <li><Link to="/submit" style={{ color: '#ccc', fontSize: '0.95rem', fontWeight: 400, textDecoration: 'none' }}>قاعدا ۽ ضابطا</Link></li>
                            <li><Link to="/submit" style={{ color: '#ccc', fontSize: '0.95rem', fontWeight: 400, textDecoration: 'none' }}>موڪلڻ جو طريقو</Link></li>
                        </ul>
                    </div>

                    {/* Column 3: Contact */}
                    <div>
                        <h4 style={{ fontSize: '0.9rem', fontWeight: 800, marginBottom: '1.5rem', color: '#fff' }}>رابطو</h4>
                        <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
                            <li><Link to="/contact" style={{ color: '#ccc', fontSize: '0.95rem', fontWeight: 400, textDecoration: 'none' }}>رابطو ڪريو</Link></li>
                            <li><Link to="/contact" style={{ color: '#ccc', fontSize: '0.95rem', fontWeight: 400, textDecoration: 'none' }}>اسان سان لکو</Link></li>
                        </ul>
                    </div>

                    {/* Column 4: Follow */}
                    <div>
                        <h4 style={{ fontSize: '0.8rem', fontWeight: 900, marginBottom: '1.5rem', color: '#fff', textTransform: 'uppercase', letterSpacing: '0.1em' }}>فالو ڪريو</h4>
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '1rem', width: 'fit-content' }}>
                            {/* Simple SVG Placeholders for Social Icons */}
                            <a href="#" aria-label="فيس بوڪ تي فالو ڪريو" style={{ color: '#fff' }}><svg width="20" height="20" fill="currentColor" viewBox="0 0 24 24"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" /></svg></a>
                            <a href="#" aria-label="ٽوئيٽر تي فالو ڪريو" style={{ color: '#fff' }}><svg width="20" height="20" fill="currentColor" viewBox="0 0 24 24"><path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.599 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z" /></svg></a>
                            <a href="#" aria-label="يوٽيوب تي فالو ڪريو" style={{ color: '#fff' }}><svg width="20" height="20" fill="currentColor" viewBox="0 0 24 24"><path d="M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.385 8.816.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0 3.897-.266 4.356-2.62 4.385-8.816-.029-6.185-.484-8.549-4.385-8.816zm-10.615 12.816v-8l8 4-8 4z" /></svg></a>
                        </div>
                    </div>

                </div>

                {/* Bottom Section: Legal & Branding */}
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: '2rem' }}>

                    <div style={{ flex: 1 }}>
                        {/* Legal Links Row */}
                        <div style={{ display: 'flex', gap: '1.5rem', marginBottom: '1rem', color: '#ccc', fontSize: '0.8rem', fontWeight: 600 }}>
                            <Link to="/privacy" style={{ color: 'inherit', textDecoration: 'none' }}>پرائيويسي پاليسي</Link>
                            <Link to="/terms" style={{ color: 'inherit', textDecoration: 'none' }}>شرط ۽ ضابطا</Link>
                            <Link to="/sitemap" style={{ color: 'inherit', textDecoration: 'none' }}>سائيٽ ميپ</Link>
                        </div>

                        {/* Copyright */}
                        <p style={{ color: '#bbb', fontSize: '0.8rem', marginBottom: '0.5rem', fontWeight: 500 }}>
                            تضاد © 2026. سڀ حق محفوظ آهن.
                        </p>
                        <p style={{ color: '#bbb', fontSize: '0.75rem', maxWidth: '500px', lineHeight: 1.4 }}>
                            هي سائيٽ محفوظ آهي ۽ پرائيويسي پاليسي ۽ شرطن جي تحت ڪم ڪري رهي آهي.
                        </p>
                    </div>

                    {/* Footer Logo */}
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '0.5rem' }}>
                        <div style={{ height: '30px', width: '136px', display: 'flex', alignItems: 'center' }}>
                            <SafeImage src={wordmark} alt="تضاد" width="136" height="30" style={{ height: '30px', width: '136px', filter: 'brightness(0) invert(1)' }} />
                        </div>
                        <span style={{ color: '#444', fontSize: '0.7rem', fontWeight: 700, letterSpacing: '0.1em' }}>سنڌي ايڊيٽوريل</span>
                    </div>

                </div>

            </div>
        </footer>
    );
};

export default Footer;
